// extracted by mini-css-extract-plugin
export default {"awsui":"style_awsui__hGFhp","modalFooter":"style_modalFooter__3Q+vh","modalContent":"style_modalContent__lwNoN"};